module.exports = __webpack_public_path__ + "static/media/river.235c2590.webp";